import { render } from "./appeal.vue?vue&type=template&id=f1647fe4"
import script from "./appeal.vue?vue&type=script&lang=js"
export * from "./appeal.vue?vue&type=script&lang=js"

import "./appeal.vue?vue&type=style&index=0&id=f1647fe4&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__